import { percentage } from '../helpers/helpers';
import './Game.scss';

function PlayerAvatar(props: {
  type: string,
  currentHP: number,
  maxHP: number
}) {


  return (
    <div className="health-bar">
      <span>{props.currentHP} / {props.maxHP}</span>
      <div
        className={`health-bar_color health-bar_${props.type}`}
        style={{ width: `${(props.currentHP / props.maxHP) * 100}%` }}
      ></div>
    </div>
  );
}

export default PlayerAvatar;
